import { useContext, useEffect, useState, Suspense, lazy } from 'react';
import './App.css';
import Navbar from './Components/Common/Navbar Section/Navbar';
import SideBar from './Components/Common/Sidebar Section/SideBar';
import Footer from './Components/Common/Footer Section/Footer';
import { Navigate, Route, Routes } from 'react-router-dom';
import ScrollToTop from './Components/Common/ScrollToTop';
import CartSidebar from './Components/Common/Cart SideBar/CartSidebar';
import { gapi } from 'gapi-script';
import { useDispatch, useSelector } from 'react-redux';
import { changeLanguage } from './Components/redux/productSlice';
import AuthContext from './Components/Common/authContext';
import CartPopupModal from './Components/Common/Cart Popup/CartPopup';
import { ToastContainer } from 'react-toastify';
import ErrorPage from './Components/Common/ErrorPage';

// Critical components (loaded immediately)
import HomeOptimized from './Components/Home page/HomeOptimized';
import ResendVerifyPage from './Components/Verify Page/ResendVerifyPage';
import AddCartPopup from './Components/Common/Add To Cart Popup/AddCartPopup';

// Lazy load non-critical page components
const BookDetailsPage = lazy(() => import('./Components/Book Details Page/BookDetailsPage'));
const BooksPage = lazy(() => import('./Components/Books page/BooksPage'));
const Cart = lazy(() => import('./Components/Cart Page/Cart'));
const Favorite = lazy(() => import('./Components/Favorite Page/Favorite'));
const Login = lazy(() => import('./Components/Login Page/Login'));
const Compare = lazy(() => import('./Components/Compare Page/Compare'));
const Register = lazy(() => import('./Components/Register page/Register'));
const ContactUsPage = lazy(() => import('./Components/Contact us Page/ContactPage'));
const OrderTracking = lazy(() => import('./Components/Order Tracking/OrderTracking'));
const FollowOrder = lazy(() => import('./Components/Order Tracking/Follow Order Page/FollowOrder'));
const Review = lazy(() => import('./Components/Order Tracking/Review page/Review'));
const AcountProfile = lazy(() => import('./Components/Account Profile Page/AcountProfile'));
const Event = lazy(() => import('./Components/Event Page/Event'));
const EventDetails = lazy(() => import('./Components/Event Page/Event Details Page/EventDetails'));
const CheckOut = lazy(() => import('./Components/CheckOut Page/CheckOut'));
const ResetPassword = lazy(() => import('./Components/Reset Password Page/ResetPassword'));
const AddReturnRefund = lazy(() => import('./Components/Return Refund Page/Add Return Reund/AddReturnRefund'));
const RetourHistory = lazy(() => import('./Components/Return Refund Page/Retour History/RetourHistory'));
const ViewRetour = lazy(() => import('./Components/Return Refund Page/View Return Refund/ViewRetour'));
const Librairie = lazy(() => import('./Components/Librairie Page/Librairie'));
const ResetPasswordEmail = lazy(() => import('./Components/Reset Password Email Page/ResetPasswordEmail'));
const VerifyPage = lazy(() => import('./Components/Verify Page/VerifyPage'));
const CollectionsPage = lazy(() => import('./Components/Collection Pages/Collections Page/Collections'));
const CollectionDetailsPage = lazy(() => import('./Components/Collection Pages/CollectionDetails Page/CollectionDetails'));
const Collaborators = lazy(() => import('./Components/Collaborators/Collaborators Page/Collaborators'));
const CollaboratorDetails = lazy(() => import('./Components/Collaborators/Collaborator Details Page/CollaboratorDetails'));
const SuccessPage = lazy(() => import('./Components/CheckOut Page/SuccessPage'));
const Mentions = lazy(() => import('./Components/Mentions Légales/Mentions'));
const CheckoutStatus = lazy(() => import('./Components/CheckOut Page/CheckoutStatus'));
const AdminPanel = lazy(() => import('./Components/Admin Panel/Menu/AdminPanel'));
const AdminLoginPage = lazy(() => import('./Components/Admin Panel/Login Form/LoginPage'));
const TrackOrder = lazy(() => import('./Components/Order Tracking/Track Order/TrackOrder'));

// Loading component for better UX
const PageLoader = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '50vh',
    fontSize: '16px',
    color: '#671929'
  }}>
    Loading...
  </div>
);

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID; 
function App() {
  const authctx = useContext(AuthContext)
  const dispatch = useDispatch();
  const [colors, setColors] = useState({
    primaryColor: '#671929',
    secondaryColor: '#E0C389',
    accentColor: '#44202E',
  });

  useEffect(() => {
    const getColors = async () => {
      setColors({
        primaryColor: authctx.companySettings?.primary_color,
        secondaryColor: authctx.companySettings?.secondary_color,
        accentColor: authctx.companySettings?.accent_color,
      });
    };
    getColors();
  }, [authctx.companySettings]);

  useEffect(() => {
    document.documentElement.style.setProperty('--primary-color', colors.primaryColor);
    document.documentElement.style.setProperty('--secondary-color', colors.secondaryColor);
    document.documentElement.style.setProperty('--accent-color', colors.accentColor);
  }, [colors]);

  const [isOpen, setIsOpen] = useState(false);
  const [cartisOpen, setcartIsOpen] = useState(false);
  const user = useSelector((state) => state.products.userInfo);
  const adminUser = useSelector((state) => state.products.adminUser);

 const toggle = () => {
   setIsOpen(!isOpen);
 };
 
 const carttoggle = () => {
  if (!cartisOpen) {
    authctx.fetchfavandcartSettings();
  }
  setcartIsOpen(!cartisOpen);
};

useEffect(() => {
  const cs = authctx.companySettings || {};
  document.getElementById('og-facebook').setAttribute('content', cs.facebook || '');
  document.getElementById('og-instagram').setAttribute('content', cs.insta || '');
  document.getElementById('og-twitter').setAttribute('content', cs.twitter || '');
  document.getElementById('og-linkedin').setAttribute('content', cs.linkedin || '');
  document.getElementById('og-youtube').setAttribute('content', cs.youtube || '');
}, [authctx.companySettings]);
useEffect (() =>{
   function start() {
     gapi.client.init({
       clientId: clientId,
       scope:''
     })
   };
  gapi.load('client:auth2', start);
 });

  // On first load, detect browser language and set selectedLanguage in redux
  useEffect(() => {
    try {
      const saved = localStorage.getItem('selectedLanguage');
      if (saved) return; // already set
      const navLang = navigator.language || navigator.userLanguage || '';
      const lower = navLang.toLowerCase();
      // treat English variants as 'eng', everything else as 'fr'
      const langObj = lower.startsWith('en') ? { Language: 'eng' } : { Language: 'fr' };
      dispatch(changeLanguage(langObj));
      localStorage.setItem('selectedLanguage', langObj.Language);
    } catch (err) {
      // ignore in non-browser environments
    }
  }, [dispatch]);
  return (
    <div className="App">
      {!window.location.pathname.includes("/admin") && (
      <>
      <Navbar toggle={toggle} carttoggle={carttoggle}/>
       <SideBar isOpen={isOpen} toggle={toggle}  carttoggle={carttoggle}/>
       <CartSidebar isOpen={cartisOpen} toggle={carttoggle}/>
       <CartPopupModal/>
       <AddCartPopup />
      </>
    )}
      
      <div style={{transition: 'opacity 0.3s ease-in-out'}}>
        <Routes>
          <Route path='/' element={<ScrollToTop><HomeOptimized carttoggle={carttoggle}/></ScrollToTop>} />
          <Route path='/productdetails/:id' element={<ScrollToTop><Suspense fallback={<PageLoader />}><BookDetailsPage carttoggle={carttoggle}/></Suspense></ScrollToTop>} />
          <Route path='/products' element={<ScrollToTop><Suspense fallback={<PageLoader />}><BooksPage carttoggle={carttoggle}/></Suspense></ScrollToTop>} />
          <Route path='/products/subcategory/:id' element={<ScrollToTop><Suspense fallback={<PageLoader />}><BooksPage carttoggle={carttoggle}/></Suspense></ScrollToTop>} />
          <Route path='/cart' element={ <ScrollToTop><Suspense fallback={<PageLoader />}><Cart/></Suspense></ScrollToTop> } />
          <Route path='/checkout' element={<ScrollToTop><Suspense fallback={<PageLoader />}><CheckOut/></Suspense></ScrollToTop>} />
          {/* <Route path='/checkout' element={user ? <ScrollToTop><CheckOut/></ScrollToTop> : <Navigate to="/login" replace />} /> */}
          <Route path='/wishlist' element={<ScrollToTop><Suspense fallback={<PageLoader />}><Favorite carttoggle={carttoggle}/></Suspense></ScrollToTop>} />
          <Route path='/login'  element={<ScrollToTop><Suspense fallback={<PageLoader />}><Login /></Suspense></ScrollToTop>} />
          {authctx?.isCompareEnabled && <Route path='/compare' element={<ScrollToTop><Suspense fallback={<PageLoader />}><Compare /></Suspense></ScrollToTop>} />}
          <Route path='/register'  element={ <ScrollToTop><Suspense fallback={<PageLoader />}><Register /></Suspense></ScrollToTop> } />
          <Route path='/contactus' element={<ScrollToTop><Suspense fallback={<PageLoader />}><ContactUsPage /></Suspense></ScrollToTop>} />
          <Route path='/ordertracking' element={user ? <ScrollToTop><Suspense fallback={<PageLoader />}><OrderTracking/></Suspense></ScrollToTop> : <Navigate to="/login" replace />}/>
          <Route path='/track-order' element={<ScrollToTop><Suspense fallback={<PageLoader />}><TrackOrder/></Suspense></ScrollToTop>} />
          <Route path='/followorder/:orderId' element={<ScrollToTop><Suspense fallback={<PageLoader />}><FollowOrder/></Suspense></ScrollToTop>} />
          <Route path='/review/:orderId' element={<ScrollToTop><Suspense fallback={<PageLoader />}><Review/></Suspense></ScrollToTop>} />
          <Route path='/reset-password' element={<ScrollToTop><Suspense fallback={<PageLoader />}><ResetPassword/></Suspense></ScrollToTop>} />
          <Route path='/verify-email' element={<ScrollToTop><Suspense fallback={<PageLoader />}><VerifyPage/></Suspense></ScrollToTop>} />
          <Route path='/resend-verify-email' element={<ScrollToTop><Suspense fallback={<PageLoader />}><ResendVerifyPage/></Suspense></ScrollToTop>} />
          <Route path='/resetpasswordemail' element={<ScrollToTop><Suspense fallback={<PageLoader />}><ResetPasswordEmail/></Suspense></ScrollToTop>} />
          <Route path="/events" element={<ScrollToTop><Suspense fallback={<PageLoader />}><Event/></Suspense></ScrollToTop>} />
          <Route path="/about-us" element={<ScrollToTop><Suspense fallback={<PageLoader />}><Librairie/></Suspense></ScrollToTop>} />
          <Route path="/eventdetails/:eventId" element={<ScrollToTop><Suspense fallback={<PageLoader />}><EventDetails/></Suspense></ScrollToTop>} />
          <Route  path='/accountprofile' element={user ? <ScrollToTop><Suspense fallback={<PageLoader />}><AcountProfile/></Suspense></ScrollToTop> : <Navigate to="/login" replace />} />
          <Route path='/add_refund_return/:order_id' element={user ? <ScrollToTop><Suspense fallback={<PageLoader />}><AddReturnRefund/></Suspense></ScrollToTop> : <Navigate to="/login" replace />} />
          <Route path='/edit_refund_return' element={user ? <ScrollToTop><Suspense fallback={<PageLoader />}><AddReturnRefund/></Suspense></ScrollToTop> : <Navigate to="/login" replace />} />
          <Route path='/refund_return' element={user ? <ScrollToTop><Suspense fallback={<PageLoader />}><ViewRetour/></Suspense></ScrollToTop> : <Navigate to="/login" replace />} />
          <Route path='/refund_return/:returnId' element={user ? <ScrollToTop><Suspense fallback={<PageLoader />}><RetourHistory/></Suspense></ScrollToTop> : <Navigate to="/login" replace />} />
          <Route path='/collections' element={<ScrollToTop><Suspense fallback={<PageLoader />}><CollectionsPage/></Suspense></ScrollToTop>} />
          <Route path='/collection-details/:id' element={<ScrollToTop><Suspense fallback={<PageLoader />}><CollectionDetailsPage/></Suspense></ScrollToTop>} />
          <Route path='/collaborator/:id/details' element={<ScrollToTop><Suspense fallback={<PageLoader />}><CollaboratorDetails/></Suspense></ScrollToTop>} />
          <Route path='/collaborators' element={<ScrollToTop><Suspense fallback={<PageLoader />}><Collaborators/></Suspense></ScrollToTop>} />
          <Route path='/order-success' element={<ScrollToTop><Suspense fallback={<PageLoader />}><SuccessPage/></Suspense></ScrollToTop>} />  
          <Route path='/checkout-result' element={<ScrollToTop><Suspense fallback={<PageLoader />}><CheckoutStatus/></Suspense></ScrollToTop>} />        
          <Route path='/collaborators' element={<ScrollToTop><Suspense fallback={<PageLoader />}><Collaborators/></Suspense></ScrollToTop>} />     
          <Route path='/legal-information' element={<ScrollToTop><Suspense fallback={<PageLoader />}><Mentions/></Suspense></ScrollToTop>} />
          <Route path="*" element={<ErrorPage />} />

          <Route path='/admin-panel' element={!adminUser?.email ? <Suspense fallback={<PageLoader />}><AdminLoginPage /></Suspense> : <Suspense fallback={<PageLoader />}><AdminPanel /></Suspense>} />
          <Route path='/admin-panel/:pageId/*' element={!adminUser?.email ? <Suspense fallback={<PageLoader />}><AdminLoginPage /></Suspense> : <Suspense fallback={<PageLoader />}><AdminPanel /></Suspense>} />
        </Routes>
      </div>
      {!window.location.pathname.includes("/admin") && (
      <Footer />
    )}
      <ToastContainer />
    </div>
  );
}

export default App;
